import React from "react";
import { observer } from "mobx-react";
import StatTile from "../visuals/StatTile";

// { label, value, unit?, decimals?, delta?, footnote?, sparkline?: [n] }
const StatTileBlock = observer(({ block }) => {
  if (block.value == null && !block.label) return null;
  return (
    <div className="cpVisual cpVisual--tile">
      <StatTile
        label={block.label}
        value={block.value}
        unit={block.unit}
        decimals={block.decimals}
        delta={block.delta}
        footnote={block.footnote}
        sparkline={block.sparkline}
        size="lg"
      />
    </div>
  );
});

export default StatTileBlock;
